import { Button, Spinner, ButtonDropdown } from "@rio-cloud/rio-uikit";
import StepForm from "../form/StepForm";
import { Dialog } from "@rio-cloud/rio-uikit";
import { useSteps } from "../../../../hooks/useSteps";
import { RestrictArea } from "../../../../components/restrictArea";

const StepsPage = () => {
  const {
    steps,
    loading,
    error,
    showForm,
    editingStep,
    handleEdit,
    handleFormClose,
    setShowForm,
    editStep,
    userHasAccess,
  } = useSteps();

  if (loading || userHasAccess === null) {
    return (
      <>
        <div className="flex justify-center items-center h-64">
          <Spinner />
        </div>
      </>
    );
  }

  if (!userHasAccess) {
    return <RestrictArea showBackButton={false} />;
  }

  if (error) {
    return (
      <>
        <div className="flex justify-center items-center h-64">
          <div className="text-red-600 text-center">
            <p className="text-lg font-semibold mb-2">Erro ao carregar etapas</p>
            <p className="text-sm">{error}</p>
          </div>
        </div>
      </>
    );
  }

  return (
    <>
      <div className="p-6 max-w-[1000px] mx-auto">
        <div className="flex justify-between items-center mb-6">
          <div>
            <div className="text-size-h2">Etapas de Ocorrência</div>
          </div>
        </div>

        <div className="bg-white dark:bg-neutral-800 rounded-lg shadow-sm overflow-hidden">
          <div className="overflow-x-auto">
            <table className="min-w-full divide-y divide-gray-200 dark:divide-neutral-700">
              <thead className="bg-gray-50 dark:bg-neutral-900">
                <tr>
                  <th className="px-6 py-3 text-left font-medium text-gray-500 dark:text-neutral-400">
                    Nome da Etapa
                  </th>
                  <th className="px-6 py-3 text-left font-medium text-gray-500 dark:text-neutral-400">
                    Tempo Decorrido para exibição de alerta
                  </th>
                  <th className="px-6 py-3 text-right font-medium text-gray-500 dark:text-neutral-400 w-[100px]">
                    Ações
                  </th>
                </tr>
              </thead>
              <tbody className="bg-white dark:bg-neutral-800 divide-y divide-gray-200 dark:divide-neutral-700">
                {steps.map((step) => (
                  <tr key={step.id} className="hover:bg-gray-50 dark:hover:bg-neutral-700">
                    <td className="px-6 py-4 whitespace-nowrap">
                      <div className="font-medium text-gray-900 dark:text-neutral-100">{step.name}</div>
                    </td>
                    <td className="px-6 py-4 whitespace-nowrap">
                      <div className="text-gray-900 dark:text-neutral-100">
                        <span className="font-medium">{step.elapsedHours}</span>
                        <span className="text-gray-500 dark:text-neutral-400 ml-1">horas</span>
                      </div>
                    </td>
                    <td className="px-6 py-4 whitespace-nowrap text-right text-sm font-medium">
                      <div className="flex justify-end space-x-2">
                        <ButtonDropdown
                          title={<span className='rioglyph rioglyph-option-vertical' />}
                          items={[
                            {
                              value: 'Editar',
                              onSelect: () => handleEdit(step)
                            }
                          ]}
                          bsStyle='muted'
                          pullRight
                          noCaret
                          usePortal
                        />
                      </div>
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>

          {steps.length === 0 && (
            <div className="text-center py-12">
              <div className="text-gray-500 dark:text-neutral-400">
                <p className="font-medium mb-2">
                  Nenhuma etapa encontrada
                </p>
              </div>
            </div>
          )}
        </div>

        {showForm && editingStep && (
          <Dialog
            show={showForm}
            onClose={handleFormClose}
            showCloseButton={true}
            title="Editar Etapa"
            bsSize={Dialog.SIZE_MD}
            body={(
              <StepForm
                step={editingStep}
                onSave={(stepId, hoursElapsed) => {
                  return editStep(stepId, hoursElapsed);
                }}
                onCancel={handleFormClose}
              />
            )}
          />
        )}
      </div>
    </>
  );
};

export default StepsPage;
